(function() {
    'use strict';

    angular.module('doclr.components.notification', [])
        .factory('notificationService', function() {
            var addNotification = function(notification, optionsInput) {

                var applyDefaults = function(options) {
                    return angular.extend({
                        delay : 5000,
                        allowDuplicates: true
                    }, options);
                };

                var options = applyDefaults(optionsInput);
                $.notify(notification.msg, {
                    type: notification.type,
                    delay: options.delay,
                    mouse_over: 'pause',
                    placement: {
                        from: 'top',
                        align: 'center'
                    },
                    animate: {
                        enter: 'animated bounceInDown',
                        exit: 'animated bounceOutUp'
                    },
                    template: '<div data-notify="container" class="col-xs-11 alert alert-{0}" style="max-width: 600px" role="alert"><button type="button" aria-hidden="true" class="close" data-notify="dismiss">&times;</button><span data-notify="icon"></span> <span data-notify="title">{1}</span> <span data-notify="message">{2}</span><div class="progress" data-notify="progressbar"><div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div><a href="{3}" target="{4}" data-notify="url"></a></div>'
                });
            };

            var service = {};

            service.showWarning = function(message, options) {
                addNotification({type: 'warning', msg: message} , options);
            };

            service.showInfo = function(message, options) {
                addNotification({type: 'info', msg: message }, options);
            };

            service.showSuccess = function(message, options) {
                addNotification({type: 'success', msg: message }, options);
            };

            service.showDanger = function(message, options) {
                addNotification({type: 'danger', msg: message }, options);
            };

            return service;
        })
        .factory('errorInterceptor', function($q, notificationService, responseErrorTranslations) {
            return {
                responseError : function(response) {
                    var defaultErrorMessage = doclrVertaal.instant('modules.notifications.defaultError') + '(' + response.status + ')';

                    if (response.status === 500) {
                        notificationService.showDanger(defaultErrorMessage);
                    } else if (response.status !== 401) {
                        var responseData = getResponseData(response);
                        var responseErrorTranslation = responseErrorTranslations[responseData.error];
                        if(responseErrorTranslation){
                            responseErrorTranslation = doclrVertaal.instant(responseErrorTranslation);
                            if(responseErrorTranslation && responseData.errorParameters){
                                for(const parameter of responseData.errorParameters){
                                    responseErrorTranslation = responseErrorTranslation.replace('[[' + parameter.name + ']]', parameter.value);
                                }
                            }
                        }
                        notificationService.showDanger(responseErrorTranslation || responseData.info || responseData.error || defaultErrorMessage);
                    }
                    return $q.reject(response);
                },
                request: function(config) {
                    if(!config.headers){
                        config.headers = {};
                    }
                    config.headers['D-Session-Token'] = 'PaukeslagBoem';
                    return config;
                },
            };

            function getResponseData(response){
                if(response.config && response.config.responseType === 'arraybuffer'){
                    try {
                      return JSON.parse(String.fromCharCode.apply(null, new Uint8Array(response.data)));
                    }catch (ex){}
                }
                return response.data;
            }
        })
        .factory('responseErrorTranslations', function() {
            return {
                'afspraakmogelijkheid.niet.meer.beschikbaar' : 'afspraakmogelijkheid.niet.meer.beschikbaar',
                'afspraken.niet.toegankelijk.voor.patienten' : 'afspraken.niet.toegankelijk.voor.patienten',
                'afspraken.algmene.voorwaarden.niet.aanvaard' :'afspraken.algmene.voorwaarden.niet.aanvaard',
                'afspraken.email.niet.gevalideerd' : 'afspraken.email.niet.gevalideerd',
                'typebeschikbaarheid.heeft.nog.afspraken' : 'typebeschikbaarheid.heeft.nog.afspraken',
                'typebeschikbaarheid.heeft.nog.beschikbaarheden.in.werkschema' : 'typebeschikbaarheid.heeft.nog.beschikbaarheden.in.werkschema',
                'typebeschikbaarheid.heeft.nog.beschikbaarheden.in.agenda' : 'typebeschikbaarheid.heeft.nog.beschikbaarheden.in.agenda',
                'oud.paswoord.niet.geldig' : 'oud.paswoord.niet.geldig',
                'afspraak.niet.meer.online.te.annuleren' : 'afspraak.niet.meer.online.te.annuleren',
                'afspraak.niet.gevonden' : 'afspraak.niet.gevonden',
                'token.niet.uniek' : 'token.niet.uniek',
                'token.niet.geldig' : 'token.niet.geldig',
                'leesbare.id.niet.uniek' : 'leesbare.id.niet.uniek',
                'eHealth.unavailable' : 'eHealth.unavailable',
                'eForm.already.sent' : 'eform.reeds.verstuurd.message',
                'errorMessage.2FA.smsservice.not.available' : 'errorMessage.2FA.smsservice.not.available',
                'eForm.document.not.found' : 'eForm.document.not.found',
                'ctpc.afspraak.datum.voor.start' : 'ctpc.afspraak.datum.voor.start',
                'ctpc.afspraak.datum.na.einde' : 'ctpc.afspraak.datum.na.einde',
                'eForm.document.rapid.test.download.error' : 'eForm.document.rapid.test.download.error',
                'eform.addressee.etk.not.found' : 'eform.addressee.etk.not.found',
                'no.appointments.found' : 'no.appointments.found',
                'appointment.already.registered' : 'appointment.already.registered',
                'multiple.appointments.found.but.one.expected' : 'multiple.appointments.found.but.one.expected',
                'covid.vaccinatie.geen.te.bevestigen.afspraken' : 'covid.vaccinatie.geen.te.bevestigen.afspraken',
                'failed_to_out_on_sftp' : 'failed_to_out_on_sftp',
                'no.vaccin.form.found' : 'no.vaccin.form.found',
                'werkschema.met.zelfde.dag' : 'werkschema.met.zelfde.dag',
                'sms.service.not.available' : 'sms.service.not.available',
                'sms.service.number.invalid' : 'sms.service.number.invalid',
                'twofa.service.number.invalid' : 'twofa.service.number.invalid',
                'vaccin.service.unavailable' : 'vaccin.service.unavailable',
                'vaccin.service.wrong.vaccintype' : 'vaccin.service.wrong.vaccintype',
                'vaccin.service.gateway.timeout' : 'vaccin.service.gateway.timeout',
                'vaccin.service.code.not.active' : 'vaccin.service.code.not.active',
                'geen.schema.beschikbaar.kies.een.ander.centrum' : 'geen.schema.beschikbaar.kies.een.ander.centrum',
                'import.covid.person.not.found' : 'import.covid.person.not.found',
                'import.covid.person.already.exists' : 'import.covid.person.already.exists',
                'uitnodiging.vorige.aanvraag.niet.verwerkt' : 'uitnodiging.vorige.aanvraag.niet.verwerkt',
                'import.covid.person.not.allowed.for.vaccintype' : 'import.covid.person.not.allowed.for.vaccintype',
                'import.covid.person.not.activated' : 'import.covid.person.not.activated',
                'appointment.not.within.24h.of.vaccination' : 'appointment.not.within.24h.of.vaccination',
                'appointment.has.wrong.status' : 'appointment.has.wrong.status',
                'vaccin.form.alread.exists' : 'vaccin.form.alread.exists',
                'import.person.has.existing.zorgtraject' : 'import.person.has.existing.zorgtraject',
                'import.person.has.existing.appointments' : 'import.person.has.existing.appointments',
                'import.person.has.wrong.vaccintype' : 'import.person.has.wrong.vaccintype',
                'werkschema.copy.to.is.not.empty' : 'werkschema.copy.to.is.not.empty',
                'vaccin.service.wrong.vaccintype.for.person' : 'vaccin.service.wrong.vaccintype.for.person',
                'vaccin.on.cancelled.appointment' : 'vaccin.on.cancelled.appointment',
                'import.covid.person.not.eligible' : 'import.covid.person.not.eligible',
                'checkin.citizen.has.refused' : 'checkin.citizen.has.refused',
            };
        })
        .config(function($httpProvider) {
            $httpProvider.interceptors.push('errorInterceptor');
        });
})();
